export default __webpack_public_path__ + "static/media/gb-sct.c952b07d.svg";